import VueDialog from './dialog';
import Dialoger from './dialoger';
import { extend } from '../util';
var Dialog = extend(VueDialog, Dialoger);
export { default as Dialog } from './dialog';
export { default as Dialoger } from './dialoger';
export default Dialog;